import React, { useState } from "react";
import { IoClose } from "react-icons/io5";
import BlueLoader from "../loader/BlueLoader";

export default function ChangeKmsConf({
  setIsKmUpdateConfOpen,
  sendAllData,
  message,
  title = "سرویس‌های گذشته قطعه",
}) {
  const [isLoading, setIsLoading] = useState(false);
  const updatePiece = () => {
    setIsLoading(true);
    sendAllData("true", setIsLoading);
    setIsKmUpdateConfOpen(false);
  };

  return (
    <div className="absolute w-full h-screen backdrop-blur-sm flex items-center justify-center z-[1000]">
      <div
        className={`relative w-[80vw] pb-[3vw] bg-[#001D26] border-color-primary-D flex flex-col items-center justify-evenly border-[1px] z-[800] rounded-[1vw] `}
      >
        {/* <span
          className="absolute text-[10vw] top-0 right-0 text-color-primary-C cursor-pointer z-[800]"
          onClick={() => {
            setIsKmUpdateConfOpen(false);
          }}
        >
          <IoClose />
        </span> */}
        <div className="w-full flex items-center justify-center bg-color-primary-D font-font_primary_A text-[#153038]">
          <span className="py-[2vw] font-bold">{title}</span>
        </div>

        <p
          className={`w-full flex items-center justify-start text-justify text-[3vw] z-[800] text-color-primary-C px-[5vw] font-font_primary_A mt-[4.5vw] leading-[6.5vw]`}
        >
          {message}
        </p>

        <div className="flex items-center justify-between gap-x-[3vw] mt-[3.7vw]">
          <button
            className="relative w-[32vw] h-[9vw] rounded-[1vw] text-center flex items-center justify-center text-[#AF3434] font-font_primary_A text-[4vw] bg-[#001D26] z-[1000]"
            onClick={() => {
              setIsKmUpdateConfOpen(false);
            }}
          >
            خیر
          </button>
          {isLoading ? (
            <div className="relative w-[32vw] h-[8vw] rounded-[1vw] text-center flex items-center justify-center text-[#474747] font-font_primary_A text-[5vw] bg-[#153038] z-[1000]">
              <BlueLoader position="" width={7} />
            </div>
          ) : (
            <button
              className="relative w-[32vw] h-[9vw] rounded-[1vw] text-center flex items-center justify-center text-[#F8F8F3] font-font_primary_A text-[4vw] bg-[#153038] z-[1000]"
              onClick={updatePiece}
            >
              بله
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
